module.exports = __webpack_public_path__ + "img/bulb-red.d36fff84.png";